import React from "react";
import { OrdersContextProvider } from "../../Context/OrdersContext";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import NewOrderManager from "./NewOrderManager";

const Order = () => {
  return (
    <OrdersContextProvider>
      <ProductsContextProvider>
        <NewOrderManager></NewOrderManager>
      </ProductsContextProvider>
    </OrdersContextProvider>
  );
};

export default Order;
